/* Landing luminoel — JS extraído de la fuente.
   Lo carga layout/landing.liquid (case 'luminoel'). */

const dialog=document.querySelector('#order');document.querySelectorAll('[data-pack]').forEach(b=>b.addEventListener('click',()=>{const two=b.dataset.pack==='2';window.__luminoel_SEL={qty:two?2:1};try{localStorage.setItem('te_regalo','luminoel|'+Date.now())}catch(e){}if(window.luminoelTriggerCOD&&window.luminoelTriggerCOD()!==false)return;document.querySelector('#packTitle').textContent=two?'2 árboles con luces':'1 árbol con luces';document.querySelector('#packDetails').textContent=two?'Dos árboles verdes de 150 cm, cada uno con base y luces incluidas.':'Un árbol verde de 150 cm, con base y luces incluidas.';document.querySelector('#packPrice').textContent=two?'$309.900':'$165.900';dialog.showModal()}));document.querySelector('.close').onclick=()=>dialog.close();document.querySelector('#back').onclick=()=>dialog.close();dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close()});const photos=Array.from(document.querySelectorAll('[data-gallery-index]'));let photoIndex=0;function showPhoto(i){photoIndex=(i+photos.length)%photos.length;const selected=photos[photoIndex].querySelector('img');document.querySelector('#gallery-main').src=photos[photoIndex].getAttribute('data-full');document.querySelector('#gallery-main').alt=selected.alt;document.querySelector('#gallery-counter').textContent=(photoIndex+1)+' / '+photos.length;photos.forEach((b,j)=>b.setAttribute('aria-pressed',String(j===photoIndex)));}photos.forEach((b,i)=>b.onclick=()=>showPhoto(i));document.querySelector('#gallery-prev').onclick=()=>showPhoto(photoIndex-1);document.querySelector('#gallery-next').onclick=()=>showPhoto(photoIndex+1);

(function(){/* contador: fecha fija, no se reinicia */
function pad(n){return String(n).padStart(2,'0')}
function tick(){const now=Date.now();document.querySelectorAll('[data-deadline]').forEach(el=>{const left=Math.max(0,new Date(el.dataset.deadline)-now);const d=Math.floor(left/864e5),h=Math.floor(left/36e5)%24,m=Math.floor(left/6e4)%60,s=Math.floor(left/1e3)%60;if(el.classList.contains('cd-inline')){el.textContent=left?(d+'d '+pad(h)+':'+pad(m)+':'+pad(s)):'HOY';return}if(!left){el.classList.add('cd-ended');el.querySelector('.cd-label').textContent='Última oportunidad: la promoción está por terminar';return}const v={d:d,h:pad(h),m:pad(m),s:pad(s)};el.querySelectorAll('[data-u]').forEach(b=>b.textContent=v[b.dataset.u])})}
tick();setInterval(tick,1000);
/* nieve sobre toda la página */
const c=document.getElementById('snow'),x=c.getContext('2d');if(matchMedia('(prefers-reduced-motion: reduce)').matches){c.remove();return}
let W,H,dpr,flakes=[];function size(){dpr=Math.min(devicePixelRatio||1,2);W=innerWidth;H=innerHeight;c.width=W*dpr;c.height=H*dpr;x.setTransform(dpr,0,0,dpr,0,0)}size();addEventListener('resize',size);
const N=innerWidth<760?55:110;function mk(top){return{x:Math.random()*W,y:top?Math.random()*-H:Math.random()*H,r:1+Math.random()*3,v:.4+Math.random()*1.1,w:Math.random()*6.28,ws:.005+Math.random()*.015}}
for(let i=0;i<N;i++)flakes.push(mk(false));
/* sorpresa: ráfaga de nieve al llegar */
for(let i=0;i<N*1.5;i++){const f=mk(true);f.burst=1;f.v+=1.2;flakes.push(f)}
let run=true;document.addEventListener('visibilitychange',()=>{run=!document.hidden;if(run)requestAnimationFrame(draw)});
function draw(){if(!run)return;x.clearRect(0,0,W,H);for(let i=flakes.length-1;i>=0;i--){const f=flakes[i];f.w+=f.ws;f.y+=f.v;f.x+=Math.sin(f.w)*.6;if(f.y>H+5){if(f.burst){flakes.splice(i,1);continue}Object.assign(f,mk(true),{y:-5})}x.beginPath();x.arc(f.x,f.y,f.r+1,0,6.28);x.fillStyle='rgba(60,80,90,.12)';x.fill();x.beginPath();x.arc(f.x,f.y,f.r,0,6.28);x.fillStyle='rgba(255,255,255,.95)';x.fill()}requestAnimationFrame(draw)}requestAnimationFrame(draw)})();

(function(){var ok=function(e){return e.target&&e.target.closest&&e.target.closest('input,textarea,select,[contenteditable],[class*="_rsi"],[id*="rsi"]')};['copy','cut','contextmenu','selectstart','dragstart'].forEach(function(t){document.addEventListener(t,function(e){if(!ok(e))e.preventDefault()},true)});document.addEventListener('keydown',function(e){var k=(e.key||'').toLowerCase();if((e.ctrlKey||e.metaKey)&&(k==='c'||k==='a'||k==='s'||k==='u'||k==='p')&&!ok(e))e.preventDefault()},true);document.querySelectorAll('img').forEach(function(i){i.setAttribute('draggable','false')})})();

/* ============================================================
   Releasit COD — variante activa + cantidad + disparo del modal
   Lo genera tools/apply_cod_trigger.py desde tools/cod_trigger.js.tpl.

   PATRÓN:
   NO se crean variantes-bundle. Dropi solo despacha las variantes que
   mapeó al IMPORTAR el producto; una variante creada después por API
   queda huérfana y el pedido no le llega (bug real de producción).
   Por eso el bundle es la MISMA variante de Dropi con quantity = N, y el
   total lo baja un descuento automático de Shopify (mín. N unidades).
   Así el pedido lleva las unidades físicas reales y Dropi las despacha.

   Releasit lee la cantidad de input[name="quantity"] en el DOM al abrir,
   y la variante de window.productData — pero SOLO la re-lee si se hace
   click en su botón nativo. _rsiV2.setState abre el modal con la variante
   cacheada al init, así que queda como último recurso.
   Depende de quantityControlsHidden:true en Releasit (ya global): si el
   cliente pudiera bajar la cantidad, pagaría el precio con descuento por
   menos unidades.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) {
      i.value = variantId;
      i.setAttribute('value', variantId);
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) {
      i.value = String(q);
      i.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  /* Qué variante y qué cantidad está eligiendo el cliente ahora mismo.
     Siempre se lee del DOM — nunca del SKU, que Dropi reescribe. */
  function qtyOf(s) {
    var q = parseInt(s && s.qty, 10);
    if (!q) { var on = document.querySelector('[data-qty].on, [data-qty].active, [data-qty][aria-checked="true"]');
      q = on ? parseInt(on.getAttribute('data-qty'), 10) : 1; }
    return q || 1;
  }
  function current() {
    var s = window.__luminoel_SEL || {};
    var V = window.LUMINOEL_VARIANTS || [];
    var v = V.filter(function (x) { return x.available; })[0] || V[0];
    return v ? { id: v.id, qty: qtyOf(s) } : null;
  }

  function sync() {
    var s = current();
    if (s && s.id) setVariantOnAllForms(s.id, s.qty);
    return s;
  }

  // el JS de la landing ya mueve la clase activa; aquí solo re-leemos después
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.__luminoel-no-watch')) {
      setTimeout(sync, 0);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', sync);
  sync();

  /* Si Releasit tiene "ofertas de cantidad" (radios quantity_offer_0/1/2 =
     1/2/3 unidades), el modal abre SIEMPRE en la primera e ignora
     input[name="quantity"]: cobra 1 unidad aunque el combo sea de 2.
     Después de abrir se marca la oferta = cantidad del combo, reintentando
     hasta que quede marcada (el modal se pinta asíncrono). */
  function selectReleasitOffer(qty) {
    var q = parseInt(qty, 10) || 1;
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      var inp = document.getElementById('quantity_offer_' + (q - 1));
      if (inp) {
        if (inp.checked) { clearInterval(t); return; }
        (inp.closest('label') || inp).click();
      } else if (tries > 100 && !document.getElementById('quantity_offer_0')) { // Releasit puede tardar ~5 s en pintar las ofertas
        clearInterval(t); // este formulario no usa ofertas de cantidad
        return;
      }
      if (tries > 120) clearInterval(t);
    }, 150);
  }

  /* El selector de variante de Releasit abre siempre en la primera variante e
     ignora el form oculto: se marca la variante elegida en la landing. */
  function selectReleasitVariant(id) {
    var gid = 'gid://shopify/ProductVariant/' + id, tries = 0;
    var t = setInterval(function () {
      tries++;
      // con oferta de 2+ unidades hay un selector por unidad; la oferta se re-pinta, así que se insiste unos segundos
      var sels = [].filter.call(document.querySelectorAll('.rsi-variant-picker-select'), function (s) {
        return [].some.call(s.options, function (o) { return o.value === gid; });
      });
      sels.forEach(function (sel) {
        if (sel.value !== gid) {
          Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set.call(sel, gid);
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      if (tries > 25) clearInterval(t);
    }, 150);
  }

  window.luminoelTriggerCOD = function () {
    var s = sync();
    if (!s || !s.id) return;
    setTimeout(function () {
      var b0 = findReleasitButton();
      if (b0) { b0.click(); selectReleasitOffer(s.qty); selectReleasitVariant(s.id); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); selectReleasitOffer(s.qty); selectReleasitVariant(s.id); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); selectReleasitOffer(s.qty); selectReleasitVariant(s.id); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  };
})();
